import React, {Component} from "react";
import {Button} from "primereact/button";
import PresvalUploadFileView from "../PresvalUploadFileView";
import {Growl} from "primereact/growl";
import {FileService} from "../../../service/file/FileService";
import PropTypes from "prop-types";

/**
 * Componente genérico para subir documentos.
 * Sólo se debe incluir en la vista o donde se quiera llamar,
 * con los parámetros que se indican.
 */
export default class UploadFileStanceContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     * Los parámetros que se le pueden poner a este componente son:
     * type: Es el tipo de archivo que recibe, con esto se va a comparar que el
     *      documento sea del mismo tipo.
     *      *Es un dato obligatorio
     * size: Tamaño máximo del archivo.
     *      *Es un dato obligatorio.
     * urlAction: Es la url que se colocará en la petición del back para subir
     *            el archivo.
     *            *Es un dato obligatorio.
     * className: Se usa igual que el del componente botón, para cambiar la apariencia
     *            del botón para buscar el archivo. No es obligatorio.
     * titleHeader: Título que se mostrará en el header del cuadro de diálogo.
     *              No es obligatorio, sino viene se mostrará: "Cargar Archivo Disponible"
     * titleButton: Texto que se mostrará en el botón.
     *              No es obligatorio, sino viene se mostrará: "Cargar Archivo"
     * errorTypeMessage: Mensaje que se mostrará cuando haya un error en el tipo de archivo.
     *              No es obligatorio, sino viene se mostrará: "Error en tipo de documento"
     * errorSizeMessage: Mensaje que se mostrará cuando haya un error en el tamaño del archivo.
     *              No es obligatorio, sino viene se mostrará: "Error en tamaño de documento"
     * instructions: Texto informativo que se muestra en el cuadro de diálogo. No es obligatorio
     * params: Parámetros que puede llevar la petición al back. Debe ser del tipo objeto:
     *         {llave: valor, llave: valor} para poder mandarlos como parámetros.
     *         No es obligatorio.
     * action: Función a la cual se va a reedirigir cuando termine de subir el archivo
     *         Por ejemplo, si se quisiera cargar de nuevo una tabla, se manda esa función.
     *         No es obligatorio."
     */
    constructor(props) {
        super(props);
        this.fileService = new FileService();
        this.state = {
            displayDialog: false,
            displayDialogPreview: false,
            fileToSave: null,
            fileName: '',
            visibleUploadResDialog: false,
            headerUploadResDialog: '',
            uploadResTemplate:''
        };
        this.openUploadFile = this.openUploadFile.bind(this);
        this.onHideDialog = this.onHideDialog.bind(this);
        this.onUpload = this.onUpload.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.onHidePreviewDialog = this.onHidePreviewDialog.bind(this);
        this.getButtonOpen = this.getButtonOpen.bind(this);
        this.getDialogHeader = this.getDialogHeader.bind(this);
        this.getDialogPreviewHeader = this.getDialogPreviewHeader.bind(this);
        //Funciones para mostrar errores al cargar archivo como un cuadro de diálogo aparte
        this.setUploadResponseTemplate = this.setUploadResponseTemplate.bind(this);
        this.onHideResDialog = this.onHideResDialog.bind(this);
        this.getUploadResponseHeader = this.getUploadResponseHeader.bind(this);
        this.getUploadResponseFooter = this.getUploadResponseFooter.bind(this);
    }

    /**
     * Función que abre el cuadro de diálogo para subir el archivo.
     */
    openUploadFile() {
        this.setState({
            fileToSave: null,
            displayDialog: true,
            fileName: '',
        });
    }

    /**
     * Función que revisa si el archivo cumple con las especificaciones
     * de tipo y tamaño.
     * @param event Objeto que contiene la información del archivo.
     */
    onUpload(event) {
        let files = event.target.files;
        if (this.props.type.find(function (find){return files[0].type === find}) === undefined) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: (this.props.errorTypeMessage ?
                    this.props.errorTypeMessage : "Error en tipo de documento")
            });
        } else if (files[0].size >= this.props.size) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: (this.props.errorSizeMessage ?
                    this.props.errorSizeMessage : "Error en tamaño de documento")
            });
        } else {
            this.setState({
                fileToSave: event.target.files[0],
                fileName: event.target.files[0].name,
            });
        }
    }

    /**
     * Función que sube el archivo por medio de una servicio en el back
     * Realiza las validaciones de que haya un archivo, que haya url para la petición,
     * y si hay params que sean del tipo requerido.
     * También llama a la función especificada en "action" en caso de que haya.
     */
    uploadFile() {
        if (this.state.fileToSave === null) {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Seleccione un archivo.'
            });
        } else if ((this.props.urlAction === null) || (this.props.urlAction === "")) {
            console.error("No se proporcionó url de la acción.");
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: "No se pudo guardar el documento"
            });
        } else {
            let paramsAux = {
                institutionId: localStorage.getItem("institutionId")
            };

            let headerUploadResDialogAux ='';
            let uploadResTemplateAux = '';
            this.fileService.uploadFile(this.state.fileToSave, this.props.urlAction, paramsAux)
                .then(res => {
                    if (res.errors === undefined || res.errors.length === 0) {
                        headerUploadResDialogAux = this.getUploadResponseHeader("Éxito");
                        uploadResTemplateAux = this.setUploadResponseTemplate(false, '');

                    } else if (res.errors.length > 0){
                        headerUploadResDialogAux = this.getUploadResponseHeader("Error al subir el archivo CSV");
                        uploadResTemplateAux = this.setUploadResponseTemplate(true, res.errors);

                    } else if (res.message && (res.message === 'Success' || res.message === 'true')) {
                        headerUploadResDialogAux =this.getUploadResponseHeader("Éxito");
                        uploadResTemplateAux = this.setUploadResponseTemplate(false, '');

                    } else if (res.error && res.error !== '') {
                        headerUploadResDialogAux = this.getUploadResponseHeader("Error al subir el archivo CSV");
                        uploadResTemplateAux = this.setUploadResponseTemplate(true, [res.error]);
                    }
                    this.setState({
                        visibleUploadResDialog: true,
                        headerUploadResDialog: headerUploadResDialogAux,
                        uploadResTemplate: uploadResTemplateAux
                    });

                    return this.props.action ? this.props.action() : "";
                });

            this.setState({
                fileToSave: null,
                displayDialog: false,
                fileName: '',
            });
        }
    }

    /**
     * Función que cierra el cuadro de diálogo
     */
    onHideDialog() {
        this.setState({displayDialog: false});
    }

    onHidePreviewDialog() {
        this.setState({displayDialogPreview: false, displayDialog: false});
    }

    getButtonOpen(){
        return <Button type="button" iconPos="left"
                       label={this.props.titleButton ?
                           this.props.titleButton : "Cargar Archivo"}
                       className={this.props.className ? this.props.className : ""}
                       onClick={this.openUploadFile}
        />
    }
    getDialogHeader(){
        return <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                <h2 className={"secondary-text"}> {this.props.titleHeader ?
                    this.props.titleHeader : "Cargar Archivo Disponible"}</h2>
            </div>
            <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                <Button label="Cancelar" onClick={this.onHideDialog}
                        className="p-button-secondary"/>
            </div>
            <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.3em'}}>
                <Button label="Guardar" onClick={this.uploadFile}/>
            </div>
        </div>;
    }

    getDialogPreviewHeader(){
        return <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                <h2>Vista Previa</h2>
            </div>
            <div className="p-col-12 p-md-6 p-lg-4" style={{padding: '.3em'}}>
                <Button label="Aceptar" onClick={this.onHidePreviewDialog}/>
            </div>
        </div>;
    }

    setUploadResponseTemplate(isError, errorList) {
        let message = '';
        let errorListTag = '';
        if (!isError) {
            message = "Se ha cargado el archivo con éxito."
        } else {
            message = "No se puede procesar el archivo debido a uno o más errores. " +
                "Corrija los errores a continuación y vuelva a cargar el archivo: ";
        }
        if (errorList.length > 0) {
            errorListTag = errorList.map((item, index) =>
                <ul>
                    <li>{item}</li>
                </ul>
            );
        }

        return <div className="p-grid ">
        <div className="p-col-12">
                <p className={"secondary-text"}
                   style={{
                       textAlign: "justify",
                       textJustify: "inter-word",
                       whiteSpace: "pre-line",
                   }}>
                    {message}
                    {errorListTag}
                </p>
            </div>
        </div>;
    }

    onHideResDialog() {
        this.setState({
            visibleUploadResDialog: false,
        });
    }

    getUploadResponseHeader(headerText){
        return <div style={{textAlign: "left"}}>
            <h2 className={"secondary-text"}> {headerText ? headerText : ""}</h2>
        </div>;
    }

    getUploadResponseFooter() {
        return <div style={{padding: '.3em', textAlign: "right"}}>
                <Button label="Aceptar" onClick={this.onHideResDialog}/>
            </div>;
    }


    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let buttonOpen = this.getButtonOpen();
        let dialogHeader = this.getDialogHeader();
        let dialogPreviewHeader = this.getDialogPreviewHeader();
        let footerUploadResDialogAux = this.getUploadResponseFooter();

        let uploadMessagesGrowl = <Growl ref={(el) => this.growl = el} style={{textAlign: 'left',}}/>;

        const {displayDialog, fileName, displayDialogPreview} = this.state;

        return <PresvalUploadFileView buttonOpen={buttonOpen}
                                      displayDialog={displayDialog}
                                      displayDialogPreview={displayDialogPreview}
                                      onHideDialog={this.onHideDialog}
                                      onUpload={this.onUpload}
                                      dialogHeader={dialogHeader}
                                      dialogPreviewHeader={dialogPreviewHeader}
                                      fileName={fileName}
                                      uploadMessagesGrowl={uploadMessagesGrowl}
                                      instructions={(this.props.instructions ? this.props.instructions : "")}
                                      onHideResDialog={this.onHideResDialog}
                                      visibleUploadResDialog={this.state.visibleUploadResDialog}
                                      headerUploadResDialog={this.state.headerUploadResDialog}
                                      uploadResTemplate={this.state.uploadResTemplate}
                                      footerUploadResDialog={footerUploadResDialogAux}
        />

    }
};

UploadFileStanceContainer.propTypes = {
    type: PropTypes.array.isRequired,
    errorTypeMessage: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    errorSizeMessage: PropTypes.string.isRequired,
    urlAction: PropTypes.string.isRequired,
    params: PropTypes.object,
    action: PropTypes.func,
    titleButton: PropTypes.string,
    className: PropTypes.string,
    titleHeader: PropTypes.string,
    instructions: PropTypes.string
}